import './B2BIndicatorsTable.css';

import React, { useContext, useState } from 'react';
import B2BTable from '../../b2b-common/B2BTable';
import { getParentLevelNsOrders, joinLevelNsIds } from './helper';
import { Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import ConfirmationModalRequest from '../../b2b-common/ConfirmationModalRequest';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import { deleteB2BIndicator } from '../../../services/b2b-frameworks-apiService';
import { LoginContext } from '../../../App';
import { callAPIWhileSettingState } from '../../b2b-common/helpers';

const B2BIndicatorsTable = ({ frameworkSuite, b2bindicators, onRemovedIndicator }) => {

    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [selectedIndicator, setSelectedIndicator] = useState(null);

    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);

    const headers = [
        { label: 'Path', align: 'left' },
        { label: 'Name', align: 'left' },
        { label: 'Scope', align: 'center' },
        { label: 'Type', align: 'center' },
        { label: 'Action', align: 'center' },
    ];

    const handleDeleteIndicator = (indicatorId) => {
        //console.log("Delete indicator: ", indicatorId);
        setSelectedIndicator(indicatorId);
        setOpenConfirmation(true);
    };

    const removeFromLevelNB2BIndicator = async (frameworkSuite, frameworkId, levelN_ItemId, indicatorUUID) => {
        try {
            const paramsArray = [
                frameworkSuite,
                frameworkId,
                levelN_ItemId,
                indicatorUUID,
                loginData.accessToken,
            ];
            await callAPIWhileSettingState(deleteB2BIndicator, paramsArray, null, null);
        } catch (error) {
            setError(error.message);
        }
    }

    const handleComfirmedDeleteIndicator = async (indicatorId) => {
        console.log("Confirmed delete indicator: ", indicatorId);
        setOpenConfirmation(false);
        // I'll bet the indicator from b2bindicators
        const indicatorToDelete = b2bindicators.find(b2bInd => b2bInd.indicatorUUID === indicatorId);
        console.log("Indicator to delete: ", indicatorToDelete);
        if (indicatorToDelete) {
            await removeFromLevelNB2BIndicator(frameworkSuite, indicatorToDelete.frameworkId,
                indicatorToDelete.levelN_ItemId, indicatorId);
            if (onRemovedIndicator) {
                onRemovedIndicator();
            }
        }
    }

    const rows = b2bindicators ? b2bindicators.map((b2bInd) => ({
        id: b2bInd.indicatorDTO.indicatorUUID,
        cells: [
            { content: `${joinLevelNsIds(getParentLevelNsOrders(b2bInd.levelN_ItemId))}`, align: 'left' },
            { content: `${b2bInd.indicatorDTO.indicatorName}`, align: 'left' },
            { content: `${b2bInd.indicatorDTO.indicatorScope}`, align: 'center' },
            { content: `${b2bInd.indicatorDTO.indicatorType}`, align: 'center' },
            {
                content: (
                    <IconButton onClick={() => handleDeleteIndicator(b2bInd.indicatorDTO.indicatorUUID)}>
                        <Delete />
                    </IconButton>
                ),
                align: 'center'
            },
        ]
    })) : [];

    const handleSelectRow = (indicatorId) => {
        console.log("Selected indicator: ", indicatorId);
    };

    //console.log("B2BIndicatorsTable: ", b2bindicators);

    return (
        (b2bindicators &&
            <>
                < B2BTableInMemory
                    headers={headers} rows={rows}
                    onRowClick={handleSelectRow}
                    className={"b2bindicators-list-table"}
                    numRows={10}
                />
                <ConfirmationModalRequest
                    open={openConfirmation}
                    handleClose={() => setOpenConfirmation(false)}
                    handleConfirm={handleComfirmedDeleteIndicator}
                    title="Delete Indicator"
                    message="Are you sure you want to delete this indicator?"
                    confirmParam={selectedIndicator}
                />
            </>
        )
    );
};

export default B2BIndicatorsTable;